import { useQueryClient } from '@tanstack/react-query'

import { productReviewSchemaPreviewQueryKey } from '../api/product-reviews-api'

import type { ProductReview } from './types'

export const useProductReviewSchemaPreview = (productCode?: string | number) => {
	const queryClient = useQueryClient()

	return productCode
		? queryClient.getQueryData<ProductReview[]>(productReviewSchemaPreviewQueryKey(productCode))
		: undefined
}
